import type { VisualizationProps } from './types';

/**
 * BathroomSVG — санузел: тумба под раковину + крючок для полотенца.
 * Зоны: ВСЕ 5 (единственный type с полным набором). Конвенции — `./types.ts`.
 */
export function BathroomSVG({
  facadeColor,
  countertopColor,
  corpusColor,
  handlesColor,
  // Defensive fallback (direct SVG usage без wrapper'а — тесты, Storybook).
  hooksColor = '#999999',
}: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      {/* Зеркало + раковина (decorative) */}
      <rect
        x="100"
        y="20"
        width="120"
        height="50"
        fill="#d8e8f0"
        stroke="#000000"
        strokeWidth="1"
        rx="3"
      />
      <rect
        x="120"
        y="92"
        width="80"
        height="10"
        fill="#e0e0e0"
        stroke="#888"
        strokeWidth="0.5"
        rx="2"
      />
      <rect
        data-testid="zone-countertop"
        x="80"
        y="100"
        width="160"
        height="12"
        fill={countertopColor}
        stroke="#000000"
        strokeWidth="1"
      />
      <rect
        data-testid="zone-corpus"
        x="80"
        y="112"
        width="160"
        height="73"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="86"
        y="116"
        width="74"
        height="65"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="162"
        y="116"
        width="74"
        height="65"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="120"
        y="146"
        width="6"
        height="2"
        fill={handlesColor}
        rx="1"
      />
      <rect x="196" y="146" width="6" height="2" fill={handlesColor} rx="1" />
      <rect
        data-testid="zone-hooks"
        x="270"
        y="100"
        width="3"
        height="12"
        fill={hooksColor}
        rx="1"
      />
      <text
        x="123"
        y="155"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="60"
        y="150"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
      <text
        x="160"
        y="98"
        textAnchor="middle"
        fontSize="8"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        3
      </text>
    </svg>
  );
}
